import React, { useState, useEffect, useRef } from "react";
import CustomModal from "../../../components/Modal/CustomModal";
import { getFromLocalStorage } from "../../../utils/common-utils";
import { CreateDND, getCountryCodeList } from "../../../api/Api";
import Swal from "sweetalert2";
import "./viewDnd.css";

const AddDndModal = ({ show, onHide, countryList = [], onSuccess }) => {
  // Initialize states with null or empty values
  const [selectedCountry, setSelectedCountry] = useState({
    id: 118,
    iso: "IN",
    name: "INDIA",
    phonecode: 91,
    msisdnLength: 10,
  });
  const [selectedOperator, setSelectedOperator] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState("");

  // Add this ref inside your component
  const dropdownRef = useRef(null);

  // Reset form when modal is opened/closed
  useEffect(() => {
    if (!show) {
      resetForm();
    }
  }, [show]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getCountryCodeList();
        console.log('Response:', JSON.stringify(response, null, 2));
        
        if (response?.countryList) {
          // Find and set India as default for both dropdowns
          const india = response.countryList.find(
            (country) => country.iso === "IN"
          );
          if (india) {
            setSelectedCountry(india); // Set default for mobile country
          }
        }
      } catch (error) {
        console.error("Error fetching country list:", error);
      }
    };
    fetchData();
  }, []);

  // Add this useEffect for handling clicks outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        // setShowCountryDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  console.log('CountryListData:', JSON.stringify(countryList, null, 2));

  const getRequiredLength = () => {
    if (!selectedCountry?.msisdnLength || !selectedCountry?.msisdnPrefix) return 0;
    return selectedCountry.msisdnLength - selectedCountry.msisdnPrefix.length;
  };

  const handleCountryChange = (e) => {
    const countryName = e.target.value;
    const country = countryList?.find((c) => c.countryName === countryName) || null;
    setSelectedCountry(country);
    setSelectedOperator(null);
    setPhoneNumber("");
  };

  const handleOperatorChange = (e) => {
    const operatorName = e.target.value;
    const operator =
      selectedCountry?.operatorList?.find(
        (op) => op.operatorName === operatorName
      ) || null;
    setSelectedOperator(operator);
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= getRequiredLength()) {
      setPhoneNumber(value);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedCountry || !selectedOperator) {
      Swal.fire({
        icon: "error",
        title: "Invalid Selection",
        text: "Please select both country and operator",
      });
      return;
    }

    if (phoneNumber.length !== getRequiredLength()) {
      Swal.fire({
        icon: "error",
        title: "Invalid Phone Number",
        text: `Please enter ${getRequiredLength()} digits after +${selectedCountry.msisdnPrefix}`,
      });
      return;
    }

    try {
      const userData = getFromLocalStorage("userData");
      const payload = {
        userId: userData?.id,
        msisdn: selectedCountry.msisdnPrefix + phoneNumber,
        operatorCode: selectedOperator?.opUniId,
        countryCode: selectedCountry?.cnUniId,
      };

      const response = await CreateDND(payload);
      if (response?.statusDescription?.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response.statusDescription.description,
        });
        onSuccess?.();
        resetForm();
        onHide?.();
      }
    } catch (error) {
      console.error("Error creating DND:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to create DND",
      });
    }
  };

  const resetForm = () => {
    setSelectedCountry(null);
    setSelectedOperator(null);
    setPhoneNumber("");
  };

  const handleClose = () => {
    resetForm();
    onHide?.();
  };


  console.log(countryList, "countryList");
  return (
    <CustomModal
      show={show}
      onHide={handleClose}
      title="Add DND Number"
      size="lg"
    >
      <form onSubmit={handleSubmit}>
        <div className="row w-100 m-0">
          <div className="form-group col-sm-4">
            {/* <div className="form-group"> */}
              <label>
                Select Country<span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                value={selectedCountry?.countryName || ""}
                onChange={handleCountryChange}
                required
              >
                <option value="">Select Country</option>
                {Array.isArray(countryList) &&
                  countryList.map((country) => (
                    <option
                      key={country?.id || Math.random()}
                      value={country?.countryName || ""}
                    >
                      {country?.countryName || ""}
                    </option>
                  ))}
              </select>
            {/* </div> */}
          </div>

          <div className="form-group col-sm-4">
            {/* <div className="form-group"> */}
              <label>
                Select Operator<span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                value={selectedOperator?.operatorName || ""}
                onChange={handleOperatorChange}
                required
                disabled={!selectedCountry}
              >
                <option value="">Select Operator</option>
                {Array.isArray(selectedCountry?.operatorList) &&
                  selectedCountry.operatorList.map((operator) => (
                    <option
                      key={operator?.id || Math.random()}
                      value={operator?.operatorName || ""}
                    >
                      {operator?.operatorName || ""}
                    </option>
                  ))}
              </select>
            {/* </div> */}
          </div>

          <div className="form-group col-sm-4">
            {/* <div className="form-group"> */}
              <label className="">
                Mobile Number<span className="text-danger">*</span>
              </label>
              <div className="input-group mobi_div">
                {selectedCountry && selectedCountry.msisdnPrefix && (
                  <span className="input-group-text">+{selectedCountry.msisdnPrefix}</span>
                )}
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Mobile Number"
                  value={phoneNumber}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    const maxLength = getRequiredLength();
                    if (maxLength && value.length <= maxLength) {
                      setPhoneNumber(value);
                    }
                  }}
                  maxLength={getRequiredLength()}
                  required
                  disabled={!selectedCountry}
                />
              </div>
              {/* {selectedCountry?.msisdnLength && (
                <small className="form-text text-muted">
                  Enter {getRequiredLength()} digits after +{selectedCountry.msisdnPrefix}
                </small>
              )} */}
            {/* </div> */}
          </div>
        </div>

        <div className="modal-footer pb-0 border-0 d-flex justify-content-between px-0 mx-0 buttons_divs">
          <button
            type="button"
            className="btn btn-secondary m-0"
            onClick={handleClose}
          >
            Close
          </button>
          <button
            type="submit"
            className="btn btn-primary m-0"
            disabled={!selectedCountry || !selectedOperator || !phoneNumber}
          >
            Submit
          </button>
        </div>
      </form>
    </CustomModal>
  );
};

export default AddDndModal;
